/**
 * Variant B — Full-bleed photo with glassmorphic card.
 *
 * Warm BPO/contact-center training photo, dark navy gradient overlay,
 * frosted-glass form card right-anchored. Refined Lumyn lockup top-left.
 */
import LumynLogo from '../LumynBrandMark';

// Warm BPO contact-center training photo (Unsplash, free for commercial use,
// stable photo ID). 2000px wide, ~85 quality keeps the file under 250 KB
// while staying crisp on Retina displays.
const PHOTO =
  'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?auto=format&fit=crop&w=2000&q=82';

export default function VariantFullBleed({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden" data-testid="login-stage">
      {/* Full-bleed photo */}
      <img
        src={PHOTO}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Cinematic warm overlay — leans into amber on the photo's right side
          so the "warm & human" tone reads even on the cool-overlaid left. */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(115deg, rgba(5,16,42,0.88) 0%, rgba(14,27,61,0.72) 30%, rgba(30,58,138,0.45) 55%, rgba(180,83,9,0.35) 100%)',
        }}
      />

      {/* Brand lockup top-left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-12 z-20">
        <LumynLogo size={36} tone="light" />
      </div>

      {/* Language switcher top-right */}
      <div className="absolute top-3 right-3 z-50">
        
      </div>

      {/* Layout */}
      <div className="relative z-10 min-h-screen flex flex-col md:flex-row md:items-center md:justify-between px-6 py-12 md:px-16 lg:px-24 gap-10">
        {/* Hero copy (left on desktop, top on mobile) */}
        <div className="md:flex-1 md:max-w-[560px] text-white">
          <p
            className="text-3xl md:text-5xl lg:text-[3.5rem] font-semibold leading-[1.08] tracking-tight"
            style={{ textShadow: '0 2px 24px rgba(0,0,0,0.45)' }}
          >
            Run the room,
            <br />
            <span style={{ color: '#FBBF24' }}>not the LMS.</span>
          </p>
          <p className="mt-5 text-white/85 text-sm md:text-base leading-relaxed max-w-[440px]">
            Lumyn is built for the trainer in the room. Author content, run
            live sessions, and review results — without forcing your
            participants to sign in.
          </p>

          {/* Lightweight credibility row — visible on desktop only */}
          <div className="hidden md:flex items-center gap-6 mt-10 text-white/75 text-xs uppercase tracking-[0.15em]">
            <span className="inline-flex items-center gap-2">
              <Dot /> Live in 60 seconds
            </span>
            <span className="inline-flex items-center gap-2">
              <Dot /> No participant accounts
            </span>
            <span className="inline-flex items-center gap-2">
              <Dot /> 6-digit ref code
            </span>
          </div>
        </div>

        {/* Glassmorphic form card */}
        <div className="md:flex-shrink-0 w-full md:w-auto flex justify-center md:justify-end">
          <div
            className="w-full max-w-[420px] rounded-2xl px-7 py-9 md:px-10 md:py-12 shadow-[0_32px_80px_-16px_rgba(0,0,0,0.55)]"
            style={{
              background: 'rgba(255,255,255,0.95)',
              backdropFilter: 'blur(24px)',
              WebkitBackdropFilter: 'blur(24px)',
              border: '1px solid rgba(255,255,255,0.5)',
              color: '#0E1B3D',
            }}
          >
            {children}
          </div>
        </div>
      </div>

      {/* Footer */}
      <p
        className="absolute bottom-5 left-0 right-0 text-center text-[11px] tracking-wider z-10"
        style={{
          color: 'rgba(255,255,255,0.65)',
          textShadow: '0 1px 8px rgba(0,0,0,0.5)',
        }}
      >
        Powered by{' '}
        <span className="font-semibold text-white">Zefficacy</span>
      </p>
    </div>
  );
}

function Dot() {
  return (
    <span
      className="inline-block w-1.5 h-1.5 rounded-full"
      style={{ background: '#FBBF24', boxShadow: '0 0 8px rgba(251,191,36,0.6)' }}
    />
  );
}
